/*------------------------------------*\
	#INPUT TELEPHONE VALIDATION
\*------------------------------------*/

import {isValidPhoneNumber, parsePhoneNumberFromString} from 'libphonenumber-js'

function initPhoneNumberValidation() {

	let phoneNumberInternational = '';

	const phoneValidationField = '.js-phone-validation-field',
		phoneValidationInput = '.js-phone-validation-input',
		phoneValidationInputHidden = '.js-phone-validation-input-hidden',
		inInvalid = 'is-invalid',
		elementPhoneField = document.querySelector(phoneValidationInput);

	if (elementPhoneField) {

		elementPhoneField.addEventListener('input', (event) => {
			const phoneFieldValue = event.target.value,
				parsedPhoneNumber = parsePhoneNumberFromString(phoneFieldValue, 'DE');

			elementPhoneField.value = phoneFieldValue;

			if (parsedPhoneNumber) {
				phoneNumberInternational = parsedPhoneNumber.formatInternational();
			}

		});

		elementPhoneField.addEventListener('blur', (event) => {

			const isPhoneNumberValidity = isValidPhoneNumber(phoneNumberInternational, 'DE'),
				elementSolarLeadField = elementPhoneField.closest(phoneValidationField),
				elementPhoneFieldHidden = document.querySelector(phoneValidationInputHidden);

			if (!isPhoneNumberValidity) {
				elementPhoneField.classList.add(inInvalid);
				elementSolarLeadField.classList.add(inInvalid);
			} else {
				elementPhoneFieldHidden.value = phoneNumberInternational;
				elementPhoneField.classList.remove(inInvalid);
				elementSolarLeadField.classList.remove(inInvalid);
			}

		});

	}
}

document.addEventListener("DOMContentLoaded", function () {
	initPhoneNumberValidation();
});
